module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch01"
    }
  }, [_vm._v("The Dawn of a New Day")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I believe that I am given a second chance every day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every morning, I wake up and think that I can do it better today, do it right, whether it’s my job or the people I touch, or don’t touch—or maybe it’s exercise, or what I eat or drink, a kindness, a new interest, or how I relate to my children, or something I learn about myself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each day is a new beginning. Trite? Maybe.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("But it works for me.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLEN")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 78
// module chunks = 0